module.exports = __webpack_public_path__ + "63228d0381e9497179e6355225d9ceed.MP3";